<template>
    <div>
        <PassengerTripCard :trip="trip" v-if="trip" class="float-container--top"></PassengerTripCard>
        <div v-if="!cancelling" class="float-container--bottom">
            <button class="btn btn-secondary btn-lg btn-heavy" @click="openCancelDialog">
                <span v-lang.cancelarConCargo v-if="trip.chofer_mitad_camino && settings.modulo_cancelar_con_cargo"></span>
                <span v-lang.cancelar v-else></span>
            </button>
        </div>
        <cancel-card @close_card="onCloseCard" @cancel_trip="onCancelTrip" v-if="cancelling && cancelReasonModuleEnabled"></cancel-card>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PassengerTripCard from './PassengerTripCard.vue';
import dialogs from '@/services/dialogs';

export default {
    name: 'passengerWaitingTrip',
    data () {
        return {
            cancelling: false
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            isMobile: 'device/isMobile',
            trip: 'passenger/actualTrip',
            position: 'geolocation/actual',
            cancelReasonModuleEnabled: 'company/cancelReasonModuleEnabled',
            settings: 'company/config'
        })
    },
    mounted () {
        this.language = this.$getLang();
        let vm = this;
        if (this.settings && this.settings.modulo_usuario_mostrador && this.settings.modulo_usuario_mostrador.enabled) {
            if (this.user && this.user.es_mostrador) {
                setTimeout(function () {
                    let data = {
                        lat: vm.position ? vm.position.lat : 0,
                        lng: vm.position ? vm.position.lng : 0
                    };
                    vm.endTrip(data);
                }, this.settings.modulo_usuario_mostrador.waitTime * 1000);
            }
        }
        if (this.settings.mostrar_mensaje_movil_en_camino && !this.mostrar_mensaje_movil_en_camino) {
            this.$alertForgettable('mostrar_mensaje_movil_en_camino', this.settings.mostrar_mensaje_movil_en_camino.mensaje);
        }
    },
    methods: {
        ...mapActions({
            cancelTrip: 'passenger/cancelTrip',
            endTrip: 'passenger/endTrip'
        }),
        openCancelDialog () {
            if (this.cancelReasonModuleEnabled) {
                this.cancelling = true;
            } else {
                let message = this.translate('confirmarCancelacion');
                if (this.trip.chofer_mitad_camino && this.settings.modulo_cancelar_con_cargo) {
                    message = this.translate('confirmarCancelacionConCargo');
                }
                dialogs.confirm(message, (index) => {
                    if (index === 1) {
                        this.onCancelTrip('CANCELANDO CONFIRMANDO');
                    }
                }, this.translate('cancelarServicio'), [this.translate('si'), this.translate('no')]);
            }
        },
        onCancelTrip (reasonText, reasonOption) {
            console.log('onCancelTrip', reasonText);
            let data = {
                lat: this.position ? this.position.lat : 0,
                lng: this.position ? this.position.lng : 0,
                comentario: reasonText
            };
            if (reasonOption) {
                data.razon_cancelacion = reasonOption;
            }
            this.cancelTrip(data);
        },
        onCloseCard () {
            this.cancelling = false;
        }

    },
    components: {
        PassengerTripCard
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/passenger/WaitingForTrip.vue